export default __webpack_public_path__ + "static/media/GF_LIV_MYST.b4c8bd88.jpg";